import React from 'react';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandHoldingHeart } from '@fortawesome/free-solid-svg-icons';
import { DonateBlock } from './../../elements/SharedElements';

const Donate = () => (
    <DonateBlock>
        <div className="container">
            <FontAwesomeIcon icon={faHandHoldingHeart} />
            <h3>Make A Donation To Support Our Projects</h3>
            <Link className="btn" to="/donate">Donate Now</Link>
        </div>
    </DonateBlock>
)

export default Donate;